// extracted by mini-css-extract-plugin
export default {"button":"PrimaryButton_button__fqhuL","icon":"PrimaryButton_icon__ewA-Y"};